import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The old one-page account screen. Most links to it pointed at its credits
 * section, so bookmarks and older e-mails land on Plan & billing.
 */
export const Route = createFileRoute("/account")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/billing", replace: true });
  },
});
